/** Base da página de configurações do sistema */
import React, { Component } from "react";
import { Layout, Menu, Icon } from "antd";
import { FaHandshake, FaPlug } from "react-icons/fa";
import { Link } from "react-router-dom";

import Base from "../Base";

const { SubMenu } = Menu;
const { Content, Sider } = Layout;

export default class BaseConfig extends Component {
  render() {
    return (
      <Base title="Configurações" subTitle="Configurações do sistema">
        <Layout>
          <Content>
            <Layout style={{ padding: "24px 0", background: "#fff" }}>
              <Sider width={200} style={{ background: "#fff" }}>
                <Menu
                  mode="inline"
                  selectable={false}
                  style={{ height: "100%" }}
                  defaultOpenKeys={["acordos", "integracoes"]}
                  className="conf__menu"
                >
                  {/* Acordos */}
                  <SubMenu
                    key="acordos"
                    title={
                      <span>
                        <Icon component={FaHandshake} />
                        Acordos
                      </span>
                    }
                  >
                    <Menu.Item key="acordos__tipos">
                      <Link to="/config/acordo/tipos">Tipos de acordo</Link>
                    </Menu.Item>
                  </SubMenu>

                  {/* Integrações */}
                  <SubMenu
                    key="integracoes"
                    title={
                      <span>
                        <Icon component={FaPlug} />
                        Integrações
                      </span>
                    }
                  >
                    <Menu.Item key="integracoes__plecto">
                      <Link to="/config/plecto/integracao">Plecto</Link>
                    </Menu.Item>
                  </SubMenu>
                </Menu>
              </Sider>
              <Content style={{ padding: "0 24px", minHeight: 280 }}>
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <span
                    style={{
                      fontSize: "16.5px",
                      fontWeight: "bold"
                    }}
                  >
                    {this.props.title}
                  </span>
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "14px",
                      color: "rgba(0, 0, 0, .6)"
                    }}
                  >
                    {this.props.subtitle}
                  </span>
                </div>
                <div style={{ marginTop: "20px" }}>{this.props.children}</div>
              </Content>
            </Layout>
          </Content>
        </Layout>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseConfig/index.js